(function ($, njm) {
    'use strict';

    njm.views.tabs = Backbone.View.extend({

        events: {
            'click .tabs li': 'chooseTab'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$tabs = this.$('.tab');
        },

        /**
         * Choose Tab
         */
        chooseTab: function (e) {

            console.log('chooseTab', $(e.currentTarget).data('tab'));

            this.$tabs.removeClass('active');
            $(e.currentTarget).siblings().removeClass('active');
            this.$tabs.filter('[data-tab="' + $(e.currentTarget).data('tab') + '"]').addClass('active');
            $(e.currentTarget).addClass('active');
        }

    });
})(jQuery, njm);
